export default {"src":"/_next/static/media/HomeLight.71c4a701.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};